export function isUsableScriptText(value: string | null | undefined): boolean {
  if (value == null) return false;
  const trimmed = value.trim();
  if (trimmed.length === 0) return false;
  const lower = trimmed.toLowerCase();
  return lower !== "null" && lower !== "undefined";
}

export function getPersonaScriptDisplayTitle(
  script: { hook: string | null; concept: string | null },
  untitled: string,
): string {
  if (isUsableScriptText(script.hook)) return script.hook!.trim();
  if (isUsableScriptText(script.concept)) return script.concept!.trim();
  return untitled;
}
